import { get } from 'lodash'
import React from 'react'
import { Intent, Position, Tag } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Flex } from '.'
import { IEmployeeSpaceAssignment, INeighborhood } from '@api/types'

interface EmployeeSpaceAssignmentProps {
  spaceAssignment?: IEmployeeSpaceAssignment | null
  secondarySpaceAssignments: IEmployeeSpaceAssignment[]
  neighborhoods: INeighborhood[]
  noDeskNeeded: boolean
  isRemote: boolean
}

export default function EmployeeSpaceAssignmentEl({
  spaceAssignment,
  secondarySpaceAssignments,
  neighborhoods,
  noDeskNeeded,
  isRemote,
}: EmployeeSpaceAssignmentProps) {
  let tag = null
  let tooltipItems: string[] = []
  const primarySpace = get(spaceAssignment, 'space')

  if (primarySpace) {
    tag = (
      <Tag minimal round intent={Intent.PRIMARY}>
        {primarySpace.externalId}
      </Tag>
    )
  }

  if (neighborhoods.length) {
    if (tag) {
      tooltipItems = [...tooltipItems, ...neighborhoods.map(({ name }) => name)]
    } else {
      tag = (
        <Tag
          round
          style={{
            backgroundColor: `#${neighborhoods[0].color}`,
            color: 'white',
          }}>
          {neighborhoods[0].name}
        </Tag>
      )
      tooltipItems = [...tooltipItems, ...neighborhoods.slice(1).map(({ name }) => name)]
    }
  }

  if (secondarySpaceAssignments.length) {
    if (tag) {
      tooltipItems = [
        ...tooltipItems,
        ...secondarySpaceAssignments.map(({ space: { externalId } }) => externalId),
      ]
    } else {
      tag = (
        <Tag
          round
          style={{
            backgroundColor: 'gold',
            color: 'var(--black)',
          }}>
          {secondarySpaceAssignments[0].space.externalId}
        </Tag>
      )
      tooltipItems = [
        ...tooltipItems,
        ...secondarySpaceAssignments.slice(1).map(({ space: { externalId } }) => externalId),
      ]
    }
  }

  if (!tag && isRemote && noDeskNeeded) {
    tag = <span>Remote/No Desk Needed</span>
  }

  if (isRemote && !tag) {
    tag = <span>Remote</span>
  }

  if (noDeskNeeded && !tag) {
    tag = <span>No Desk Needed</span>
  }

  if (!tag) {
    tag = (
      <Tag minimal round intent={Intent.DANGER}>
        Unseated
      </Tag>
    )
  }

  return (
    <Flex align="center">
      {tag}
      <ExtraSpaceCount tooltipItems={tooltipItems} />
    </Flex>
  )
}

function ExtraSpaceCount({ tooltipItems }: { tooltipItems: string[] }) {
  if (!tooltipItems.length) {
    return null
  }

  const label = <span style={{ color: 'var(gray1)', marginLeft: 5 }}>+{tooltipItems.length}</span>

  return tooltipItems.length ? (
    <Tooltip2 content={tooltipItems.join(' | ')} position={Position.TOP}>
      {label}
    </Tooltip2>
  ) : (
    label
  )
}
